import { Box } from '@mui/material'
import React from 'react'

const EDProgressBar = ({ progress, sx, progressColor = 'alternate.main' }) => {
  return (
    <Box width="300px" height="8px" borderRadius="4px" backgroundColor="#EDEFF0" sx={{ ...sx }}>
      <Box
        sx={{ width: `${progress}%` }}
        height="100%"
        borderRadius="5px"
        backgroundColor={progressColor}
      />
    </Box>
  )
}

export default EDProgressBar
